import { armorAPI } from '~/services/api';

function sendAdditionalInformation(payload) {
  return armorAPI.request({
    url: 'setting/user-info',
    method: 'POST',
    data: payload,
  });
}

function sendRegistrationSource(payload: { reg_source: string }) {
  return armorAPI.request({
    url: 'setting/user-info/registration-source',
    method: 'PUT',
    data: payload,
  });
}

export { sendAdditionalInformation, sendRegistrationSource };
